/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { WithDirtyType, WithEntityState } from '@gh/common-shared-data';
import { PbCcElementDto } from '@gh/builder-shared-data';

export type PbBulkUpdateHPMarkup = WithDirtyType<WithEntityState<{
  housePlans: any[];
  qqMarkup: number;
  total: number;
  profit: number;
  contingency: number;
  overhead: number;
}>>;

export type PbBulkUpdateICMarkup = WithDirtyType<WithEntityState<{
  items: any[];
  itemMarkup: number;
  compMarkup: number;
  deletePct: number;
  costCenter: any;
}>>;
export const getPbItemComponentId = (item: PbCcElementDto) => `${item.itemId}${item.costCenterId}`;
